export default __webpack_public_path__ + "static/media/marker.81bd9c7f.png";